import { call, take, put } from 'redux-saga/effects';
import { post } from '../../utils/api';
import settings from '../../utils/settings';
import { GRID_LIST_REQUEST, GRID_LIST_SUCCESS, REQUEST_FAILURE, GRID_LIST_REQUEST_SELF_INSTALLER } from './constants';

export function* getGridList() {
  while (true) {
    const request = yield take(GRID_LIST_REQUEST);
    try {
      let response;
      const { companyId, page, limit } = request.payload;
      response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/company/${companyId}/grid-profiles?limit=${limit}&page=${page}`)
      });
      if (response.success) {
        const { result } = response;
        if (result !== []) {
          yield put({ type: GRID_LIST_SUCCESS, gridList: response.result });
        } else {
          yield put({ type: REQUEST_FAILURE, error: result.message });
        }
      }
    } catch (error) {
      console.log('Saga: getGridList:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* getSelfInstallerGridList() {
  while (true) {
    const request = yield take(GRID_LIST_REQUEST_SELF_INSTALLER);
    try {
      let response;
      const { page, limit } = request.payload;
      response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/self_installer/grid-profiles?limit=${limit}&page=${page}`)
      });
      if (response.success) {
        const { result } = response;
        if (result !== []) {
          yield put({ type: GRID_LIST_SUCCESS, gridList: response.result });
        } else {
          yield put({ type: REQUEST_FAILURE, error: result.message });
        }
      }
      else if (response && !response.success) {
        const { result } = response;
        yield put({ type: REQUEST_FAILURE, error: result.message });
      }
    } catch (error) {
      console.log('Saga: getGridList:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}